/* eslint-disable @typescript-eslint/no-explicit-any */

export const removeNode = (cy: any, node?: { id?: string | number } | null) => {
  if (!node) return null;

  const selectedElements =
    JSON.parse(localStorage.getItem('selectedElements') || '[]') || [];

  if (Array.isArray(selectedElements) && selectedElements.length !== 0) {
    selectedElements.forEach((el: any) => {
      const id = el?.id != null ? String(el.id) : null;
      if (id) cy.remove(cy.getElementById(id));
    });
  }

  const nodeId = node?.id != null ? String(node.id) : null;
  if (nodeId) cy.remove(cy.getElementById(nodeId));

  return null;
};
